/** @jsx h */
import { h, Component } from 'preact'
import { pageViewEvent } from '../../utils/analytics'
import * as analytics from '../../../utils/analytics'

class JourneyCoverView extends Component {
  componentDidMount () {
    const { href } = this.props
    analytics.track('productStoryViewed', { href })
    analytics.track('productStory_viewed', {
      object: 'productStory',
      action: 'viewed'
    }, { adapter: 'segment' })
    if (href) {
      pageViewEvent(href)
    }
  }

  render ({ id, title, backgroundUrl, description, disabled }) {
    if (disabled) return null

    const divStyle = {
      backgroundImage: `url(${backgroundUrl})`
    }

    return (
      <article id={`${id}-0`} class='Journey' style={divStyle}>
        <div class='Journey-content noselect'>
          <h1 class='Journey-title'>{title}</h1>
          <p class='Journey-description noselect'>{description}</p>
        </div>
      </article>
    )
  }
}

JourneyCoverView.defaultProps = {
  href: null,
  description: ''
}

export default JourneyCoverView
